var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "File Lockup / * Elements / FIle Format / ZIP - Large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707078",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474751",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File-Lockup-/-*-Elements-/-FIle-Format-/-ZIP---Large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2857143,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,29 C0,30.6568542 1.34314575,32 3,32 L25,32 C26.6568542,32 28,30.6568542 28,29 L28,19.1383298 L27.986028,18.9715388 C27.9307508,18.6443867 27.7151376,18.3614456 27.4051378,18.2240741 L24.284,16.842 L24.2857143,3 C24.2857143,1.34314575 22.9425685,0 21.2857143,0 Z",
    id: "Rectangle-Copy-15",
    fill: "#D6D6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,6 L15,6 C15.5522847,6 16,6.44771525 16,7 C16,7.55228475 15.5522847,8 15,8 L13.3333333,8 L13.3333333,10 L15,10 C15.5522847,10 16,10.4477153 16,11 C16,11.5522847 15.5522847,12 15,12 L13.3333333,12 L13.3333333,14 L15,14 C15.5522847,14 16,14.4477153 16,15 C16,15.5522847 15.5522847,16 15,16 L13.3333333,16 L13.3333333,18 L15,18 C15.5522847,18 16,18.4477153 16,19 C16,19.5522847 15.5522847,20 15,20 L13.3333333,20 L13.3333333,22 L15,22 C15.5522847,22 16,22.4477153 16,23 C16,23.5522847 15.5522847,24 15,24 L13.3333333,24 L13.3333333,25.6666667 C13.3333333,26.2189514 12.8856181,26.6666667 12.3333333,26.6666667 C11.7810486,26.6666667 11.3333333,26.2189514 11.3333333,25.6666667 L11.3333333,24 L9.66666667,24 C9.11438192,24 8.66666667,23.5522847 8.66666667,23 C8.66666667,22.4477153 9.11438192,22 9.66666667,22 L11.3333333,22 L11.3333333,20 L9.66666667,20 C9.11438192,20 8.66666667,19.5522847 8.66666667,19 C8.66666667,18.4477153 9.11438192,18 9.66666667,18 L11.3333333,18 L11.3333333,16 L9.66666667,16 C9.11438192,16 8.66666667,15.5522847 8.66666667,15 C8.66666667,14.4477153 9.11438192,14 9.66666667,14 L11.3333333,14 L11.3333333,12 L9.66666667,12 C9.11438192,12 8.66666667,11.5522847 8.66666667,11 C8.66666667,10.4477153 9.11438192,10 9.66666667,10 L11.3333333,10 L11.3333333,8 L9.66666667,8 C9.11438192,8 8.66666667,7.55228475 8.66666667,7 C8.66666667,6.44771525 9.11438192,6 9.66666667,6 L11.3333333,6 L11.3333333,4 L9.66666667,4 C9.11438192,4 8.66666667,3.55228475 8.66666667,3 C8.66666667,2.44771525 9.11438192,2 9.66666667,2 L11.3333333,2 L11.3333333,0 L13.3333333,0 L13.3333333,2 L15,2 C15.5522847,2 16,2.44771525 16,3 C16,3.55228475 15.5522847,4 15,4 L13.3333333,4 L13.3333333,6 Z",
    id: "Combined-Shape-Copy-5",
    fill: "url(#linearGradient-1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.b73853702951b3277b52dc8074af6097.svg";
export { ForwardRef as ReactComponent };